export default __webpack_public_path__ + "static/media/westfield-direct.inline.6e214bcc.svg";